import React from "react";
import { useAuth } from "../hooks/useAuth";
import { Navigate, Route, Routes } from "react-router-dom";

// routes config
import { PrivateRoute } from "./PrivateRoute";
import { SuperAdminRoute } from "./SuperAdminRoute";

// pages auth
import Login from "../pages/Auth/Login";

// pages app
import Users from "../pages/App/Users";
import School from "../pages/App/Schools";
import Courses from "../pages/App/Courses";
import Lessons from "../pages/App/Lessons";
import Subjects from "../pages/App/Subjects";
import Resources from "../pages/App/Resources";
import Grades from "../pages/App/Grades";
import Programs from "../pages/App/Program";
import GameQuizzes from "../pages/App/GameQuizzes";
import Calendar from "../pages/App/Calendar";
import DiaryTeacher from "../pages/App/DiaryTeacher";
import GameDiagnostics from "../pages/App/GameDiagnostics";
import SubidorSupersonico from "../pages/App/SubidorSupersonico";
import HubSubida from "../pages/App/HubSubida";
import DemoProvision from "../pages/App/DemoProvision";
import Activity from "../pages/App/Activity";
import Trash from "../pages/App/Trash";
import ContentMap from "../pages/App/ContentMap";
import AttentionQueue from "../pages/App/AttentionQueue";
import Attempts from "../pages/App/Attempts";
import SandboxResources from "../pages/App/SandboxResources";
import Dashboard from "../pages/App/Dashboard";
import Settings from "../pages/App/Settings";
import AdminAccess from "../pages/App/AdminAccess";
import AppVersion from "../pages/App/AppVersion";
import RevisionODs from "../pages/App/RevisionODs";
import ReviewRunView from "../pages/App/RevisionODs/ReviewRunView";
import QuizRetrievalChat from "../pages/QuizRetrievalChat";
import DataQuestions from "../pages/DataQuestions";

// Forms components
import UsersForm from "../components/Forms/UserForm";
import SchoolForm from "../components/Forms/SchoolForm";
import CourseForm from "../components/Forms/CourseForm";
import LessonForm from "../components/Forms/LessonForm";
import SubjectForm from "../components/Forms/SubjectForm";
import ResourceForm from "../components/Forms/ResourceForm";
import GradeForm from "../components/Forms/GradeForm";
import ProgramForm from "../components/Forms/ProgramForm";
import GameQuizForm from "../components/Forms/GameQuizForm";
import TiendaPaquetes from "../pages/App/TiendaPaquetes";
import TiendaPaqueteForm from "../components/Forms/TiendaPaqueteForm";
import Ventas from "../pages/App/Ventas";
import Formacion from "../pages/App/Formacion";
import TeacherProgress from "../pages/App/TeacherProgress";

const authRoutes = () => {
  return (
    <>
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </>
  );
};

const appRoutes = () => {
  return (
    <>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/users"
        element={
          <PrivateRoute>
            <Users />
          </PrivateRoute>
        }
      />
      <Route
        path="/users/new"
        element={
          <PrivateRoute>
            <UsersForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/users/:id"
        element={
          <PrivateRoute>
            <UsersForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/schools"
        element={
          <PrivateRoute>
            <School />
          </PrivateRoute>
        }
      />
      <Route
        path="/schools/:id"
        element={
          <PrivateRoute>
            <SchoolForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/schools/new"
        element={
          <PrivateRoute>
            <SchoolForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/courses"
        element={
          <PrivateRoute>
            <Courses />
          </PrivateRoute>
        }
      />
      <Route
        path="/courses/:id"
        element={
          <PrivateRoute>
            <CourseForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/courses/new"
        element={
          <PrivateRoute>
            <CourseForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/lessons"
        element={
          <PrivateRoute>
            <Lessons />
          </PrivateRoute>
        }
      />
      <Route
        path="/lessons/:id"
        element={
          <PrivateRoute>
            <LessonForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/lessons/new"
        element={
          <PrivateRoute>
            <LessonForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/subjects"
        element={
          <PrivateRoute>
            <Subjects />
          </PrivateRoute>
        }
      />
      <Route
        path="/subjects/:id"
        element={
          <PrivateRoute>
            <SubjectForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/subjects/new"
        element={
          <PrivateRoute>
            <SubjectForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/resources"
        element={
          <PrivateRoute>
            <Resources />
          </PrivateRoute>
        }
      />
      <Route
        path="/resources/:id"
        element={
          <PrivateRoute>
            <ResourceForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/resources/new"
        element={
          <PrivateRoute>
            <ResourceForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/grades"
        element={
          <PrivateRoute>
            <Grades />
          </PrivateRoute>
        }
      />
      <Route
        path="/grades/:id"
        element={
          <PrivateRoute>
            <GradeForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/grades/new"
        element={
          <PrivateRoute>
            <GradeForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/programs"
        element={
          <PrivateRoute>
            <Programs />
          </PrivateRoute>
        }
      />
      <Route
        path="/programs/:id"
        element={
          <PrivateRoute>
            <ProgramForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/programs/new"
        element={
          <PrivateRoute>
            <ProgramForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/game-quizzes"
        element={
          <PrivateRoute>
            <GameQuizzes />
          </PrivateRoute>
        }
      />
      <Route
        path="/game-quizzes/new"
        element={
          <PrivateRoute>
            <GameQuizForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/game-quizzes/:id"
        element={
          <PrivateRoute>
            <GameQuizForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/quiz-retrieval"
        element={
          <PrivateRoute>
            <QuizRetrievalChat />
          </PrivateRoute>
        }
      />
      <Route
        path="/attempts"
        element={
          <PrivateRoute>
            <Attempts />
          </PrivateRoute>
        }
      />
      <Route
        path="/recursos-prueba"
        element={
          <PrivateRoute>
            <SandboxResources />
          </PrivateRoute>
        }
      />
      <Route
        path="/calendar"
        element={
          <PrivateRoute>
            <Calendar />
          </PrivateRoute>
        }
      />
      <Route
        path="/diary-teacher"
        element={
          <PrivateRoute>
            <DiaryTeacher />
          </PrivateRoute>
        }
      />
      <Route
        path="/game-diagnostics"
        element={
          <PrivateRoute>
            <GameDiagnostics />
          </PrivateRoute>
        }
      />
      <Route
        path="/subidor-supersonico"
        element={
          <PrivateRoute>
            <SubidorSupersonico />
          </PrivateRoute>
        }
      />
      <Route
        path="/hub-subida"
        element={
          <PrivateRoute>
            <HubSubida />
          </PrivateRoute>
        }
      />
      <Route
        path="/demo-provision"
        element={
          <PrivateRoute>
            <DemoProvision />
          </PrivateRoute>
        }
      />
      <Route
        path="/tienda-paquetes"
        element={
          <PrivateRoute>
            <TiendaPaquetes />
          </PrivateRoute>
        }
      />
      <Route
        path="/tienda-paquetes/new"
        element={
          <PrivateRoute>
            <TiendaPaqueteForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/tienda-paquetes/:id"
        element={
          <PrivateRoute>
            <TiendaPaqueteForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/ventas"
        element={
          <PrivateRoute>
            <Ventas />
          </PrivateRoute>
        }
      />
      <Route
        path="/formacion"
        element={
          <PrivateRoute>
            <Formacion />
          </PrivateRoute>
        }
      />
      <Route
        path="/progreso-profesores"
        element={
          <PrivateRoute>
            <TeacherProgress />
          </PrivateRoute>
        }
      />
      <Route
        path="/papelera"
        element={
          <PrivateRoute>
            <Trash />
          </PrivateRoute>
        }
      />
      <Route
        path="/actividad"
        element={
          <PrivateRoute>
            <Activity />
          </PrivateRoute>
        }
      />
      <Route
        path="/mapa-contenido"
        element={
          <PrivateRoute>
            <ContentMap />
          </PrivateRoute>
        }
      />
      <Route
        path="/atencion"
        element={
          <PrivateRoute>
            <AttentionQueue />
          </PrivateRoute>
        }
      />
      <Route
        path="/accesos"
        element={
          <SuperAdminRoute>
            <AdminAccess />
          </SuperAdminRoute>
        }
      />
      <Route
        path="/version-app"
        element={
          <PrivateRoute>
            <AppVersion />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <PrivateRoute>
            <Settings />
          </PrivateRoute>
        }
      />
      <Route
        path="/revision-ods"
        element={
          <PrivateRoute>
            <RevisionODs />
          </PrivateRoute>
        }
      />
      <Route
        path="/revision-ods/:runId"
        element={
          <PrivateRoute>
            <ReviewRunView />
          </PrivateRoute>
        }
      />
      <Route
        path="/consultas"
        element={
          <PrivateRoute>
            <DataQuestions />
          </PrivateRoute>
        }
      />
      <Route
        path="/consultas/:threadId"
        element={
          <PrivateRoute>
            <DataQuestions />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </>
  );
};

const RoutesApp = () => {
  // const url = window.location.href;
  // const query = window.location.pathname;
  const { token } = useAuth();

  if (token === undefined) return null;

  return <Routes>{!token ? authRoutes() : appRoutes()}</Routes>;
};

export default RoutesApp;
